import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const toggleSwitchStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:min-h-(--base-space-px-24)
      iris:w-fit
      iris:cursor-pointer
      iris:items-center
      iris:gap-(--comp-space-gap-toggle-switch)
      iris:duration-(--comp-motion-duration-toggle-switch)
      iris:ease-(--comp-motion-easing-toggle-switch)
      iris:focus-visible:rounded-xs
      iris:data-[disabled=true]:pointer-events-none
      iris:data-[disabled=true]:opacity-(--sem-opacity-interactive-disabled)
    `,
        label: `
      iris:cursor-pointer
      iris:font-(family-name:--comp-type-font-toggle-switch-label)
      iris:text-(length:--comp-type-size-toggle-switch-label)
      iris:leading-(--comp-type-leading-toggle-switch-label)
      iris:font-(--comp-type-weight-toggle-switch-label)!
      iris:tracking-(--comp-type-tracking-toggle-switch-label)
      iris:text-(--comp-color-content-toggle-switch-label-default)
      iris:not-italic
      iris:select-none
      iris:hover:text-(--comp-color-content-toggle-switch-label-default)
      iris:focus-visible:text-(--comp-color-content-toggle-switch-label-default)
    `,
        track: `
      iris:relative
      iris:flex
      iris:h-(--comp-size-box-toggle-switch-track-height)
      iris:w-(--comp-size-box-toggle-switch-track-width)
      iris:cursor-pointer
      iris:items-center
      iris:rounded-(--comp-size-radius-toggle-switch-track)
      iris:bg-(--comp-color-background-toggle-switch-track-rest)
      
      iris:outline-hidden
      iris:hover:bg-(--comp-color-background-toggle-switch-track-hover)
      iris:focus-visible:bg-(--comp-color-background-toggle-switch-track-pressed)
      iris:active:bg-(--comp-color-background-toggle-switch-track-pressed)
      iris:data-[behavior=focusing]:bg-(--comp-color-background-toggle-switch-track-pressed)
      iris:data-[behavior=hovering]:bg-(--comp-color-background-toggle-switch-track-hover)
      iris:data-[disabled=true]:bg-(--comp-color-background-toggle-switch-track-disabled)
      
      iris:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-rest)
      iris:hover:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-hover)
      iris:focus-visible:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-pressed)
      iris:active:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-pressed)
      iris:data-[behavior=focusing]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-pressed)
      iris:data-[behavior=hovering]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-hover)
    `,
        handle: `
      iris:block
      iris:size-(--comp-size-box-toggle-switch-handle)
      iris:rounded-full
      iris:border-(length:--comp-size-border-toggle-switch-handle)
      iris:border-(--comp-color-border-toggle-switch-handle-rest)
      iris:bg-(--comp-color-background-toggle-switch-handle-rest)
      iris:transition-transform
      iris:duration-(--comp-motion-duration-toggle-switch)
      iris:ease-(--comp-motion-easing-toggle-switch)
      
      iris:will-change-transform
      iris:outline-none
      
      iris:hover:border-(--comp-color-border-toggle-switch-handle-hover)
      iris:focus-visible:border-(--comp-color-border-toggle-switch-handle-pressed)
      
      iris:active:border-(--comp-color-border-toggle-switch-handle-pressed)
      iris:data-[behavior=focusing]:border-(--comp-color-border-toggle-switch-handle-pressed)
      iris:data-[behavior=hovering]:border-(--comp-color-border-toggle-switch-handle-hover)
      
      iris:data-[disabled=true]:border-(--comp-color-border-toggle-switch-handle-disabled)
      iris:data-[disabled=true]:bg-(--comp-color-background-toggle-switch-handle-disabled)
      
      iris:data-[state=checked]:translate-x-[calc(var(--comp-size-box-toggle-switch-track-width)-var(--comp-size-box-toggle-switch-handle))]
      iris:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-rest)
      iris:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-rest)
      
      iris:hover:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-hover)
      iris:focus-visible:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-pressed)
      
      iris:active:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-pressed)
      iris:data-[behavior=focusing]:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-pressed)
      iris:data-[behavior=hovering]:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-hover)
    `,
        backdrop: `
      iris:size-full
      iris:rounded-full
      
      iris:hover:bg-(--comp-color-background-toggle-switch-handle-hover)
      iris:focus-visible:bg-(--comp-color-background-toggle-switch-handle-pressed)
      iris:active:bg-(--comp-color-background-toggle-switch-handle-pressed)
      iris:data-[behavior=focusing]:bg-(--comp-color-background-toggle-switch-handle-pressed)
      iris:data-[behavior=hovering]:bg-(--comp-color-background-toggle-switch-handle-hover)
      
      iris:hover:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-hover)
      iris:focus-visible:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-pressed)
      iris:active:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-pressed)
      iris:data-[behavior=focusing]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-pressed)
      iris:data-[behavior=hovering]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-hover)
    `,
    },
    variants: {
        inverse: {
            false: {
                container: focusStyles.default,
            },
            true: {
                container: focusStyles.inverse,
                label: `
          iris:text-(--comp-color-content-toggle-switch-label-inverse)
          iris:hover:text-(--comp-color-content-toggle-switch-label-inverse)
          iris:focus-visible:text-(--comp-color-content-toggle-switch-label-inverse)
        `,
                track: `
          iris:bg-(--comp-color-background-toggle-switch-track-inverse-rest)
          iris:hover:bg-(--comp-color-background-toggle-switch-track-inverse-hover)
          iris:focus-visible:bg-(--comp-color-background-toggle-switch-track-inverse-pressed)
          iris:active:bg-(--comp-color-background-toggle-switch-track-inverse-pressed)
          iris:data-[behavior=focusing]:bg-(--comp-color-background-toggle-switch-track-inverse-pressed)
          iris:data-[behavior=hovering]:bg-(--comp-color-background-toggle-switch-track-inverse-hover)
          
          iris:data-[disabled=true]:bg-(--comp-color-background-toggle-switch-track-inverse-disabled)
          
          iris:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-rest)
          iris:hover:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-hover)
          iris:focus-visible:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-pressed)
          iris:active:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-pressed)
          iris:data-[behavior=focusing]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-pressed)
          iris:data-[behavior=hovering]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-track-selected-inverse-hover)
        `,
                handle: `
          iris:border-(--comp-color-border-toggle-switch-handle-inverse-rest)
          iris:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-rest)
          
          iris:hover:border-(--comp-color-border-toggle-switch-handle-inverse-hover)
          iris:focus-visible:border-(--comp-color-border-toggle-switch-handle-inverse-hover)
          
          iris:active:border-(--comp-color-border-toggle-switch-handle-inverse-hover)
          iris:data-[behavior=focusing]:border-(--comp-color-border-toggle-switch-handle-inverse-pressed)
          iris:data-[behavior=hovering]:border-(--comp-color-border-toggle-switch-handle-inverse-hover)
          
          iris:data-[disabled=true]:border-(--comp-color-border-toggle-switch-handle-inverse-disabled)
          iris:data-[disabled=true]:bg-(--comp-color-background-toggle-switch-handle-inverse-disabled)
          
          iris:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-rest)
          iris:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-rest)
          
          iris:hover:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-hover)
          iris:focus-visible:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-pressed)
          iris:active:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-pressed)
          iris:data-[behavior=focusing]:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-pressed)
          iris:data-[behavior=hovering]:data-[state=checked]:border-(--comp-color-border-toggle-switch-handle-selected-inverse-hover)
        `,
                backdrop: `
          iris:hover:bg-(--comp-color-background-toggle-switch-handle-inverse-hover)
          iris:focus-visible:bg-(--comp-color-background-toggle-switch-handle-inverse-pressed)
          iris:active:bg-(--comp-color-background-toggle-switch-handle-inverse-pressed)
          iris:data-[behavior=focusing]:bg-(--comp-color-background-toggle-switch-handle-inverse-pressed)
          iris:data-[behavior=hovering]:bg-(--comp-color-background-toggle-switch-handle-inverse-hover)
          
          iris:hover:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-hover)
          iris:focus-visible:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-pressed)
          iris:active:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-pressed)
          iris:data-[behavior=focusing]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-pressed)
          iris:data-[behavior=hovering]:data-[state=checked]:bg-(--comp-color-background-toggle-switch-handle-selected-inverse-hover)
        `,
            },
        },
        align: {
            left: {},
            right: {
                container: `iris:flex-row-reverse`,
            },
        },
        disabled: {
            true: {},
            false: {},
        },
    },
    defaultVariants: {
        inverse: false,
        align: "left",
    },
});

export { toggleSwitchStyles as default };
